import Chart from '@app/components/atoms/Chart/Chart'
import { toDataChart, toTotal } from '@app/libs/dashboardFormat'
import { formatNumber, toMonthString } from '@app/libs/format'
import { optionsBarLine, optionsPie } from '@app/modules/Partner/Dashboard/ChartOption'
import { BarLine, dataChart, dataChartNumber } from '@data/ChartData'
import Grid from '@mui/material/Grid'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

const Dashboard = ({
  sumCodes,
  partnersCount,
  merchantsCount,
  campaignDetailWeekly,
  campaignDetailMonthly,
  merchantCategories,
  campaignDetailCurrentDay,
  categoriesVoucher,
  countRedeemedUsed,
  valueRedeemedUsed,
}) => {
  const { t, i18n } = useTranslation()

  const vouchersCategoryChartData = dataChart(
    'TOTAL_VOUCHERS_CATEGORY',
    categoriesVoucher.filter((item) => 0 < item.vouchers_count),
    toTotal(categoriesVoucher, 'vouchers_count'),
    'vouchers_count'
  )
  const merchantsCategoryChartData = dataChart(
    'TOTAL_MERCHANTS_CATEGORY',
    merchantCategories.filter((item) => 0 < item.merchants_count),
    toTotal(merchantCategories, 'merchants_count'),
    'merchants_count'
  )

  const countRedeemedUsedToDataChart = toDataChart(countRedeemedUsed, 'redeemed', 'used')
  const valueRedeemedUsedToDataChart = toDataChart(valueRedeemedUsed, 'redeemed_price', 'used_price')

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Chart
            data={dataChartNumber(
              t('ADMIN_DASHBOARD.TOTAL_PARTNERS'),
              t('ADMIN_DASHBOARD.PARTNERS'),
              partnersCount.partners_count
            )}
            type="number"
          />
        </Grid>

        <Grid item xs={4}>
          <Chart
            data={dataChartNumber(
              t('ADMIN_DASHBOARD.TOTAL_MERCHANTS'),
              t('ADMIN_DASHBOARD.MERCHANTS'),
              merchantsCount.merchants_count
            )}
            type="number"
          />
        </Grid>

        <Grid item xs={4}>
          <Chart
            data={{
              title: t('ADMIN_DASHBOARD.LABEL_CODE_USED_AMOUNT'),
              tag: t('ADMIN_DASHBOARD.LABEL_CODE_USED_AMOUNT'),
              label: t('ADMIN_DASHBOARD.LABEL_CODE_AMOUNT', {
                textEn: 'redeemed',
                textVn: 'đã quy đổi',
              }),
              redeem: formatNumber(sumCodes.count_used),
              scope: null,
              total: formatNumber(parseInt(sumCodes.count_redeemed) + parseInt(sumCodes.count_used)),
            }}
            type="barLine"
          />
        </Grid>

        <Grid item xs={4}>
          <Chart
            data={dataChartNumber(
              t('ADMIN_DASHBOARD.TOTAL_CAMPAIGN_RUNNING_CURRENT'),
              t('ADMIN_DASHBOARD.CAMPAIGNS'),
              campaignDetailCurrentDay.campaigns_count
            )}
            type="number"
          />
        </Grid>

        <Grid item xs={4}>
          <Chart
            data={dataChartNumber(
              t('ADMIN_DASHBOARD.TOTAL_CAMPAIGN_EXPIRED_NEXT_WEEK'),
              t('ADMIN_DASHBOARD.CAMPAIGNS'),
              campaignDetailWeekly.campaigns_count
            )}
            type="number"
          />
        </Grid>

        <Grid item xs={4}>
          <Chart
            data={dataChartNumber(
              t('ADMIN_DASHBOARD.TOTAL_CAMPAIGN_EXPIRED_NEXT_MONTH'),
              t('ADMIN_DASHBOARD.CAMPAIGNS'),
              campaignDetailMonthly.campaigns_count
            )}
            type="number"
          />
        </Grid>

        <Grid item xs={6}>
          <Chart
            data={BarLine(
              t('ADMIN_DASHBOARD.LABEL_CODE_VALUE', { textEn: 'redeemed', textVn: 'đã quy đổi' }),
              t('ADMIN_DASHBOARD.LABEL_CODE_AMOUNT', { textEn: 'redeemed', textVn: 'đã quy đổi' }),
              countRedeemedUsedToDataChart,
              valueRedeemedUsedToDataChart,
              'redeemed',
              'redeemed_price'
            )}
            styleChart={{ options: optionsBarLine }}
            styleGird={{ lg: 12, md: 12, xs: 12 }}
            title={t('ADMIN_DASHBOARD.CHART_AMOUNT_AND_VALUE_REDEEMED_IN_MONTH', {
              number: toMonthString(moment()),
            })}
            type="bar"
          />
        </Grid>
        <Grid item xs={6}>
          <Chart
            data={BarLine(
              t('ADMIN_DASHBOARD.LABEL_CODE_VALUE', { textEn: 'used', textVn: 'đã sử dụng' }),
              t('ADMIN_DASHBOARD.LABEL_CODE_AMOUNT', { textEn: 'used', textVn: 'đã sử dụng' }),
              countRedeemedUsedToDataChart,
              valueRedeemedUsedToDataChart,
              'used',
              'used_price'
            )}
            styleChart={{ options: optionsBarLine }}
            styleGird={{ lg: 12, md: 12, xs: 12 }}
            title={t('ADMIN_DASHBOARD.CHART_AMOUNT_AND_VALUE_USED_IN_MONTH', { number: toMonthString(moment()) })}
            type="bar"
          />
        </Grid>
        <Grid item xs={4}>
          <Chart
            data={vouchersCategoryChartData}
            styleChart={{ options: optionsPie(t, i18n) }}
            styleGird={{ lg: 12, md: 12, xs: 12 }}
            title={t(`ADMIN_DASHBOARD.${vouchersCategoryChartData.label}`)}
            type="doughnut"
          />
        </Grid>
        <Grid item xs={4}>
          <Chart
            data={merchantsCategoryChartData}
            styleChart={{ options: optionsPie(t, i18n) }}
            styleGird={{ lg: 12, md: 12, xs: 12 }}
            title={t(`ADMIN_DASHBOARD.${merchantsCategoryChartData.label}`)}
            type="doughnut"
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Dashboard
